import React, { Suspense } from 'react';

import { lazyWithNullFallback } from 'components/layout/util';
import { useLDContext } from 'state/launchdarkly';
import { useLoyaltyContext } from 'state/loyalty';

const LoyaltyOptInModalContent = lazyWithNullFallback(() =>
  import('pages/loyalty/loyalty-opt-in-modal/loyalty-opt-in-modal-content')
);

export default () => {
  const { ldUserIsAuthenticated } = useLDContext();
  const { loyaltyEnabled } = useLoyaltyContext();

  if (!loyaltyEnabled || !ldUserIsAuthenticated) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LoyaltyOptInModalContent data-testid="loyalty-opt-in-modal" />
    </Suspense>
  );
};
